import type { CredentialStatus } from '../../services/sprayCredential';

interface Props {
  status: CredentialStatus;
  className?: string;
}

const STYLES: Record<CredentialStatus, { label: string; cls: string }> = {
  valid:          { label: 'Valid',     cls: 'bg-emerald-100 text-emerald-700 border-emerald-200' },
  expiring_soon:  { label: 'Expiring',  cls: 'bg-amber-100 text-amber-700 border-amber-200' },
  expired:        { label: 'Expired',   cls: 'bg-rose-100 text-rose-700 border-rose-200' },
  missing:        { label: 'Missing',   cls: 'bg-neutral-100 text-neutral-600 border-neutral-200' },
};

function CredentialStatusBadge({ status, className }: Props) {
  const { label, cls } = STYLES[status];
  return (
    <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium ${cls} ${className || ''}`}>
      {label}
    </span>
  );
}

export default CredentialStatusBadge;
